<template>
  <div class="Reportform">
    <el-form class="custom-formScreen" :model="formScreen" ref="formScreen" inline label-width="4.8vw"
      style="margin-top: 20px">
      <el-form-item prop="branchCompanyId" label="选择分公司" v-if="[1].includes(UserInfo.type)">
        <el-select filterable v-model="formScreen.branchCompanyId" value-key="company_id"
          @change="selectChange($event, 'listSonCompany')">
          <el-option v-for="item in listBranchCompany" :key="item.company_id" :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sonCompanyId" label="选择子公司" v-if="[2, 1].includes(UserInfo.type)">
        <el-select filterable v-model="formScreen.sonCompanyId" value-key="rid"
          @change="selectChange($event, 'listDepartment')">
          <el-option v-for="item in listSonCompany" :key="item.company_id" :label="item.companyName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择平台" prop="sellerType">
        <el-select v-model="formScreen.sellerType" placeholder="请选择" @change="shopChange8" clearable>
          <el-option v-for="item in platform" :key="item.sellerType" :label="item.itemTypeName"
            :value="item.sellerType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="departmentVal" label="选择分部门"
        v-if="UserInfo.system < 3 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.departmentVal" value-key="rid" @change="selectChange($event, 'listGroup')">
          <el-option v-for="item in listDepartment" :key="item.rid" :label="item.departmentName"
            :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="groupVal" label="选择组"
        v-if="UserInfo.system < 4 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.groupVal" value-key="rid" @change="selectChange($event, 'listStaff')">
          <el-option v-for="item in listGroup" :key="item.rid" :label="item.groupName" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="staffVal" label="选择员工"
        v-if="UserInfo.system < 5 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')">
        <el-select v-model="formScreen.staffVal" value-key="rid" @change="selectChange($event, 'none')">
          <el-option v-for="item in listStaff" :key="item.rid" :label="item.roleUserName" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sid" label="选择店铺">
        <el-select v-model="formScreen.sid" :disabled="isShopDisabled" @change="changeShop">
          <el-option v-for="item in listShop" :key="item.id" :label="item.shop_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="state" label="店铺状态">
        <el-select v-model="formScreen.state">
          <el-option label="正常" value="1"></el-option>
          <el-option label="失效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="uid" label="选择用户">
        <el-select v-model="formScreen.uid" @change="changeUser">
          <el-option :label="item.userName" :value="item.uid" v-for="item in userList" :key="item.uid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="startTime" label="开始日期">
        <el-date-picker v-model="formScreen.startTime" type="datetime" placeholder="选择开始日期"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item prop="endTime" label="结束日期">
        <el-date-picker v-model="formScreen.endTime" type="datetime" placeholder="选择结束日期"
          value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input placeholder="店铺名称，商户ID搜索" v-model="formScreen.searchVal" style="width: calc(100% - 140px);"></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm"
          :loading="searchBtnLoading">搜索</el-button>
        <el-button type="primary" @click="resetForm" :loading="searchBtnLoading">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="table-batch">
      <div>
        <el-button type="danger" style="margin-right: 10px;opacity: 0;">
          批量删除
        </el-button>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="importVisible=true">
          独立站月租导入
        </el-button>
        <el-popover
          placement="left"
          trigger="click"
          style="float: right; margin-right: 10px;">
          <div>
            <el-date-picker
              v-model="daochudata"
              type="month"
              size="small"
              value-format="yyyy-MM"
              placeholder="选择日期">
            </el-date-picker>
            <el-button type="primary" @click="daochusubmit" style="float: right; margin-left: 10px;">
              确定
            </el-button>
          </div>
          <el-button type="primary" slot="reference">
            月租成本导出
          </el-button>
        </el-popover>
      </div>
    </div>
    <el-table key="third" :data="listTable" border v-loading="loadingTable">
      <el-table-column prop="shop_name" label="店铺名称" align="center"></el-table-column>
      <el-table-column prop="sellerId" label="商户ID" align="center"></el-table-column>
      <el-table-column prop="roleName" label="角色" align="center"></el-table-column>
      <el-table-column prop="platformType" label="独立站平台" align="center"></el-table-column>
      <el-table-column prop="currentStandaloneRental.monthlyRentAmount" label="当前月租" align="center"></el-table-column>
      <el-table-column prop="currentStandaloneRental.monthlyFeeRate" label="当前手续费(%)" align="center"></el-table-column>
      <el-table-column prop="currentStandaloneRental.effectiveTime" label="此费率生效时间" align="center"></el-table-column>
      <el-table-column prop="currentStandaloneRental.storeStatus" label="店铺状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.currentStandaloneRental" :style="{ color: scope.row.currentStandaloneRental.storeStatus == 1 ? 'green' : 'red' }">{{
            scope.row.currentStandaloneRental.storeStatus == 1 ? '生效' :
              '失效'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="addRenewal(scope.row)">新增续费</el-button>
          <el-button type="primary" size="small" @click="getHistoryData(scope.row)">查看历史记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="center" align="middle" class="pagination-box">
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="page"
        :page-sizes="[20, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </el-row>

    <el-dialog title="修改提现费用比例" width="30%" :visible.sync="dialogVisible">
      <el-form label-width="80px">
        <el-form-item label="提现比例">
          <el-input v-model="withdrawalRatio2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateWithdrawalRatio" :loading="loadingStatus === 'dialogVisible'">确
          定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增续费" width="25%" :visible.sync="RenewalVisible" @close="close">
      <el-form label-width="100px" :model="formData" :rules="rules" ref="formData">
        <el-form-item label="独立站平台">
          {{ currentPlatformType }}
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="套餐选择" prop="taocan">
          <el-select v-model="formData.taocanid" filterable @change="changeTaocan">
            <el-option v-for="item in renewals" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="formData.taocan">
          <el-row :gutter="20">
            <el-col :span="12" :offset="0">
              <el-form-item label="月租">
                {{ formData.taocan.monthlyRentAmount }} {{ ' ' + formData.taocan.currencyCode }}
                <el-input type="hidden" style="display: none"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="0">
              <el-form-item label="手续费">
                {{ formData.taocan.monthlyFeeRate }}%
                <el-input type="hidden" style="display: none"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="生效时间" prop="value1">
            <el-date-picker v-model="formData.value1" type="date" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="续费时间" prop="renewalTime">
            <el-date-picker v-model="formData.renewalTime" type="date" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="续费时长" prop="value2">
            <el-input-number v-model="formData.value2" size="small" :min="1" :step="1"></el-input-number>
            天
          </el-form-item>
          <el-form-item label="失效时间">
            {{ endTime }}
            <el-input type="hidden" style="display: none"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="RenewalVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('formData')" :loading="loadingStatus === 'RenewalVisible'">确
          定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看历史记录" width="50%" :visible.sync="historyVisible">
      <div slot="title" class="historyTitle">
        <div>查看历史记录</div>
        <div>独立站平台: {{ currentPlatformType }}</div>
      </div>
      <ul class="historyUl" :class="historyLoading ? 'historyLoading' : ''" v-loading="historyLoading">
        <li v-for="item in historyData" :key="id">
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>{{ item.name }}</strong>
            </el-col>
            <el-col :span="7" :offset="0" v-if="item.isprobation == 1">
              免费天数 <strong>{{ item.freeDays }}</strong> 天
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>{{ item.effectiveTime }}</strong>
            </el-col>
            <el-col :span="7" :offset="0" v-if="item.isprobation == 0">
              结束时间 <strong>{{ item.expirationTime }}</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              {{ item.isprobation == 1 ? '试用' : '' }}期间费率 <strong>{{ item.monthlyFeeRate }}%</strong>
            </el-col>
          </el-row>
        </li>
      </ul>
    </el-dialog>

    <el-dialog
      title="独立站月租导入"
      :visible.sync="importVisible"
      width="30%"
      @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写，该时区为美东-4时区时间。</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <div><span style="color: red">导入异常信息：</span></div>
        <span v-for="(item, index) in errorList" :key="index+'w'">{{ item }}<br /></span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          @click="handleUploadExcelSubmit"
          :loading="btnLoading"
        >确定导入
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '@/api/api/api';
export default {
  name: "IndependentStationMonthlyRentImport",
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick: (picker) => {
            const date = new Date()
            picker.$emit('pick', date);
            this.calculationDate()
          }
        }, {
          text: '上一月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-1)
          }
        }, {
          text: '上两月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-2)
          }
        }, {
          text: '上三月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-3)
          }
        }]
      },
      UserInfo: {},
      companyId: '',
      rid: '',
      system: '',
      formScreen: {
        branchCompanyId: '',
        sonCompanyId: '',
        departmentVal: '',
        groupVal: '',
        staffVal: '',
        sid: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        sellerType: ''
      },
      listBranchCompany: [],
      listSonCompany: [],
      listDepartment: [],
      listGroup: [],
      listStaff: [],
      listShop: [],
      dialogVisible: false,
      withdrawalRatio2: '',
      loadingStatus: '',
      listTable: [],
      loadingTable: false,
      page: 1,
      size: 20,
      total: 0,
      platform: [],
      searchBtnLoading: false,
      formData: {},
      RenewalVisible: false,
      historyVisible: false,
      historyData: [],
      historyLoading: false,
      currentPlatformType: '',
      renewals: [],
      rules: {
        taocan: [{ required: true, message: '请选择套餐', trigger: 'change' }],
        renewalTime: [{ required: true, message: '请选择续费时间', trigger: 'change' }],
        value1: [{ required: true, message: '请选择生效时间', trigger: 'change' }],
        value2: [{ required: true, message: '请输入续费时长', trigger: 'change' }]
      },
      currentRow: {},
      importVisible: false,
      listFile: [],
      errorList: '',
      returnList: [],
      btnLoading: false,
      sidList: [],
      userList: [],
      daochudata: ''
    };
  },
  computed: {
    isShopDisabled() {
      if (this.UserInfo.system === 5 && this.UserInfo.superDepartmentName === '运营部') {
        return false
      } else {
        return !this.formScreen.staffVal
      }
    },
    screenObj() {
      return {
        company_id: this.companyId,
        rid: this.rid,
        system: this.system,
        sid: this.formScreen.sid,
      }
    },
    endTime() {
      if (this.formData.value1 && this.formData.value2) {
        let strdate = this.formData.value1
        var isdate = new Date(strdate.replace(/-/g,"/"))
        isdate = new Date((isdate/1000+(86400*(this.formData.value2-1)))*1000)
        var pdate = isdate.getFullYear()+"-"+(isdate.getMonth()+1)+"-"+(isdate.getDate())
        return pdate
      }
      return '-'
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getTable()
    this.getUsers()
    if (this.UserInfo.type === 3) {
      this.getPlatform();
    }
  },
  methods: {
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      } else {
        listType = "listDepartment";
      }
      if (type === 3) {
        if (system === 3) {
          listType = "listGroup";
        } else if (system === 4) {
          listType = "listStaff";
        }
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    shopChange8() {
      if (this.UserInfo.type !== 3) {
        this.rid = this.formScreen.sonCompanyId.rid;
        this.system = this.UserInfo.system;
      } else {
        this.rid = this.UserInfo.rid;
        this.system = this.UserInfo.system;
      }
      this.getNextPower(this.rid, this.system, this.companyId, 'listDepartment');
      this.formScreen.departmentVal = '';
      this.formScreen.groupVal = '';
      this.formScreen.staffVal = '';
      this.listStaff = [];
      this.formScreen.sid = '';
      this.listShop = []
      this.listGroup = [];
    },
    getPlatform() {
      const API = Baseurl + 'sellerController/selectStandalonePlatformList'
      const paramsData = {
        rid: this.rid
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.platform = res.data.data
        } else {
          this.platform = []
          this.$message.error(res.data.data)
        }
      })
    },
    getUsers() {
      const API = Baseurl + 'userControllers/selectUserListAndSidListByCompanyId'
      const paramsData = {
        companyId: this.UserInfo.company_id
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.userList = res.data.data
        } else {
          this.userList = []
          this.$message.error(res.data.data)
        }
      })
    },
    changeUser() {
      this.formScreen.sellerType = ''
      this.formScreen.departmentVal = ''
      this.formScreen.groupVal = ''
      this.formScreen.staffVal = ''
      this.formScreen.sid = ''
      this.sidList = this.userList.filter(x => x.uid == this.formScreen.uid)[0].sidList
    },
    changeTaocan() {
      this.formData.taocan = this.renewals.filter(x => x.id == this.formData.taocanid)[0]
    },
    getNextPower(rid, system, companyId, type) {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      let paramsData = { rid, system, companyId, sellerType: this.formScreen.sellerType };

      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
          this.sidList = data.sidList
        }
      });
    },
    selectChange(event, type) {
      this.formScreen.uid = ''
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);
      if (!system) this.system = this.UserInfo.system;
      if (!companyId) this.companyId = this.UserInfo.company_id;
      if (!rid) this.rid = this.UserInfo.rid;

      this.listShop = []
      this.formScreen.sid = ''
      if (type === "none") {
        this.getListShop()
        return;
      }
      this.getNextPower(rid, system, companyId, type);

      if (type == "listDepartment") {
        this.getPlatform();
      }

      this.formScreen.staffVal = {};
      this.listStaff = [];
      if (type === "listStaff") return;
      this.formScreen.groupVal = {};
      this.listGroup = [];
      if (type === "listGroup") return;
      this.formScreen.departmentVal = {};
      this.listDepartment = [];
      this.formScreen.sellerType = '';
      this.platform = [];
      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    changeShop() {
      this.formScreen.uid = ''
    },
    getTable() {
      const API = Baseurl + 'sellerController/selectStandaloneSellerList'
      const paramsData = {
        page: this.page,
        size: this.size,
        startTime: this.formScreen.startTime || '',
        endTime: this.formScreen.endTime || '',
        searchString: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        uid: this.formScreen.uid,
        state: this.formScreen.state,
        ...this.screenObj,
        sidList: this.sidList
      }
      if (this.formScreen.sid) {
        paramsData.sidList = [this.formScreen.sid]
      }
      this.loadingTable = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTable = false
        this.searchBtnLoading = false
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    getListShop() {
      const API = Baseurl + 'sellerController/selectMyShopByRid1'
      const paramsData = {
        rid: this.rid,
        system: this.system
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listShop = data
        }
      })
    },
    searchForm() {
      this.searchBtnLoading = true
      this.page = 1
      this.getTable()
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.listBranchCompany = [];
      this.listSonCompany = [];
      this.listDepartment = [];
      this.listGroup = [];
      this.listStaff = [];
      this.listShop = [];
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.companyId = this.UserInfo.company_id

      this.init();
      this.searchForm()
    },
    handleSizeChange1(val) {
      this.size = val
      this.getTable()
    },
    handleCurrentChange1(val) {
      this.page = val
      this.getTable()
    },
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = (month + type - 1 + 12) % 12 + 1;
      this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

      const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
      this.formScreen.endTime = `${prevMonth} 23:59:59`
    },
    updateWithdrawalRatio() {
      const API = Baseurl + 'companyController/updateCompanyWithdrawalRatio'
      const paramsData = {
        id: this.UserInfo.company_id,
      }
      this.loadingStatus = 'dialogVisible'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.UserInfo.company = data
          localStorage.setItem('role', JSON.stringify(this.UserInfo))
          this.$message.success('操作成功')
          this.searchForm()
          this.dialogVisible = false
        }
      })
    },
    getHistoryData(row) {
      this.historyVisible = true
      this.historyData = []
      this.historyLoading = true
      this.currentPlatformType = row.platformType
      ajaxPost(Baseurl + 'standaloneRentalController/selectStandaloneRentalHistoricalData', { companyId: this.UserInfo.company_id, sellerId: row.sellerId }).then(res => {
        if (res.data.code == 200) {
          this.historyData = res.data.data
          this.historyLoading = false
        } else {
          this.$message.error(res.data.data)
          this.historyLoading = false
        }
      }).catch(() => { this.historyLoading = false })
    },
    addRenewal(row) {
      this.currentRow = row
      this.currentPlatformType = row.platformType
      this.RenewalVisible = true
      ajaxPost(Baseurl + 'standalonePackageSettingsController/selectStandalonePackageSettings', { companyId: this.UserInfo.company_id, platformType: Number(row.sellerType) }).then(res => {
        this.renewals = res.data.data
      })
    },
    submit(formData) {
      this.$refs[formData].validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.formData.taocan))
          item.packageId = item.id
          delete item.id
          let obj = {
            ...item,
            sellerType: Number(this.currentRow.sellerType),
            sellerId: this.currentRow.sellerId,
            companyId: this.UserInfo.company_id,
            rid: this.UserInfo.rid,
            effectiveTime: this.formData.value1,
            validDuration: this.formData.value2,
            renewalTime: this.formData.renewalTime,
            expirationTime: this.endTime
          }
          this.loadingStatus = 'RenewalVisible'
          ajaxPost(Baseurl + 'standaloneRentalController/insertStandaloneRental', obj).then(() => {
            this.getTable()
            this.loadingStatus = ''
            this.close()
            this.$message.success('新增成功')
          }).catch(() => {
            this.loadingStatus = ''
            this.$message.error('服务器出错，请联系客服')
          })
        }
      })
    },
    close() {
      this.formData = {}
      this.RenewalVisible = false
    },
    handleUploadExcelDialogClose() {
      this.importVisible = false
      this.listFile = []
      this.errorList = ''
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = results.map(item => ({
        sellerId: item.商户id,
        name: item.套餐名称,
        effectiveTime: this.formatDate(item.生效时间, '-'),
        validDuration: Number(item.有效时长),
        expirationTime: this.formatDate(item.失效时间, '-'),
      }))
      console.log(results);
      console.log(returnList);
      let bool1 = false
      let bool2 = false
      let bool3 = false
      returnList.map(item => {
        if (item.effectiveTime == "NaN-NaN-NaN") {
          bool1 = true
        }
        if (item.expirationTime == "NaN-NaN-NaN") {
          bool2 = true
        }
        if (isNaN(item.validDuration)) {
          bool3 = true
        }
      })
      if (bool1 == true) {
        this.$message.error("生效时间格式有误，请按照正确格式填写！")
        return
      }
      if (bool2 == true) {
        this.$message.error("失效时间格式有误，请按照正确格式填写！")
        return
      }
      if (bool3 == true) {
        this.$message.error("有效时长只能填写数字，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear() ;
      const month = time.getMonth() + 1 ;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E6%9C%88%E7%A7%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E6%9C%88%E7%A7%9F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelSubmit() {
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'standaloneRentalController/importStandaloneRental/'+this.UserInfo.rid, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList
          } else {
            this.importVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    daochusubmit() {
      if (!this.daochudata) {
        this.$message.error('请先选择时间！')
        return
      }
      window.open(`${Baseurl}/standaloneRentalController/storeMonthlyRentExport?month=${this.daochudata}&companyId=${this.companyId}`, 'target');
    },
  }
};
</script>

<style lang="scss" scoped>
.Reportform {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .table-batch {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    overflow: hidden;
    line-height: 40px;
    padding-bottom: 3px;
    margin-bottom: 5px;
    padding-top: 3px;
    background-color: #f9f3f3;
  }

  .historyTitle {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 100px;
  }

  .historyUl {
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    &.historyLoading {
      min-height: 100px;
    }

    li {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>
